// TintiCloud — Integrações. Dados de demonstração.
export const integrations = [
  { id: "docker", name: "Docker", detail: "sv1 · Engine", version: "v26.1.3", status: "connected", meta: "68 containers", icon: "docker" },
  { id: "npm", name: "Nginx Proxy Manager", detail: "Proxy hosts", version: "v2.15.1", status: "connected", meta: "31 hosts", icon: "npm" },
  { id: "cloudflare", name: "Cloudflare", detail: "DNS & CDN", version: "API v4", status: "connected", meta: "5 zonas", icon: "cloudflare" },
  { id: "github", name: "GitHub / Git", detail: "Repositórios", version: "—", status: "connected", meta: "3 repositórios", icon: "github" },
  { id: "vault", name: "Vault de Secrets", detail: "Segredos", version: "—", status: "connected", meta: "12 secrets", icon: "vault" },
  { id: "email", name: "E-mail (Postfix)", detail: "SMTP / IMAP", version: "—", status: "warning", meta: "2 domínios", icon: "email" },
];

export const infraStatus = { label: "Todos os sistemas operacionais", ok: true, uptime: "99.98%" };
